import theme from "assets/theme";
import React, { useEffect, useState } from "react";
import { StyleSheet, Text, View } from "react-native";
import MetaService from "services/Meta.service";

const classes = StyleSheet.create({
  root: {
    flexDirection: "row",
    justifyContent: "center",
    alignItems: "center",
    gap: 20,
    paddingVertical: 5,
    paddingHorizontal: 16,
    backgroundColor: theme.color.black,
    borderTopWidth: 1,
    borderTopColor: theme.color.greyHighlight,
  },
  text: {
    color: theme.color.darkGrey,
    fontSize: 11,
  },
  envTag: {
    color: theme.color.yellow,
    fontWeight: "bold",
    fontSize: 11,
  },
});

export default function AppFooter() {
  const [footerInfo, setFooterInfo] = useState(null);

  useEffect(() => {
    MetaService.getFooterInfo()
      .then((res) => {
        if (res?.payload?.showFooter === "true") {
          setFooterInfo(res.payload);
        }
      })
      .catch(() => {});
  }, []);

  if (!footerInfo) {
    return null;
  }

  return (
    <View style={classes.root}>
      {footerInfo.nodeEnv != null && (
        <Text style={classes.envTag}>{footerInfo.nodeEnv.toUpperCase()}</Text>
      )}
      {footerInfo.appVersion != null && (
        <Text style={classes.text}>v{footerInfo.appVersion}</Text>
      )}
      {footerInfo.frontendBase != null && (
        <Text style={classes.text}>{footerInfo.frontendBase}</Text>
      )}
    </View>
  );
}
